export function handleObject(object) {
  return {
    type: 'HANDLE_OBJECT',
    payload: object
  };
}
